/**
 * Parse watchdog "product details change" status messages into rows for display.
 * Backend sends a single line like: "Title: N/A → …, Image updated, Brand: N/A → X"
 */

var CELL_TRUNCATE = 60

/** Split only before known field labels so commas inside titles do not break segments. */
var SEGMENT_SPLIT = /,\s+(?=(?:Title|Brand|Manufacturer|Description|Bullet(?:\s+Point)?|Image|Images|Item type|Product type|Generic keyword|Color|Material|Size|Browse node|Pattern|Style)\b)/i

function normalizeArrowIndex (rest) {
  var i = rest.indexOf(' → ')
  if (i >= 0) return { i: i, len: 3 }
  i = rest.indexOf(' -> ')
  if (i >= 0) return { i: i, len: 4 }
  i = rest.indexOf('→')
  if (i >= 0) return { i: i, len: 1 }
  i = rest.indexOf('->')
  if (i >= 0) return { i: i, len: 2 }
  return null
}

export function parseProductDetailChangeRows (raw) {
  if (raw == null || typeof raw !== 'string') return null
  var text = raw.trim()
  if (!text) return null

  var parts = text.split(SEGMENT_SPLIT).map(function (s) { return s.trim() }).filter(Boolean)
  if (parts.length === 0) return null

  var rows = []
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i]
    if (/^images?\s+updated$/i.test(p)) {
      rows.push({ field: 'Image', before: '—', after: 'Updated' })
      continue
    }
    var m = p.match(/^([^:]+):\s*([\s\S]*)$/)
    if (!m) return null
    var field = m[1].trim()
    var rest = m[2]
    var arrow = normalizeArrowIndex(rest)
    if (arrow) {
      var before = rest.slice(0, arrow.i).trim()
      var after = rest.slice(arrow.i + arrow.len).trim()
      rows.push({ field: field, before: before, after: after })
    } else {
      rows.push({ field: field, before: '—', after: rest.trim() })
    }
  }
  return rows.length ? rows : null
}

/** Single shorthand "Image updated" row — show plain message instead of the Field/Before/After table. */
export function isImageOnlyUpdatedRows (rows) {
  if (!rows || rows.length !== 1) return false
  var r = rows[0]
  if (String(r.field).trim().toLowerCase() !== 'image') return false
  var b = String(r.before == null ? '' : r.before).trim()
  var a = String(r.after == null ? '' : r.after).trim()
  if (!/^updated$/i.test(a)) return false
  return b === '' || b === '—' || b === '-' || b === '–' || /^n\/a$/i.test(b)
}

export function formatChangeCellBefore (v) {
  if (v == null) return '—'
  var t = String(v).trim()
  if (!t) return '—'
  if (/^n\/a$/i.test(t)) return '(not previously tracked)'
  return t
}

export function formatChangeCellAfter (v) {
  if (v == null) return '—'
  var t = String(v).trim()
  if (!t) return '—'
  if (/^n\/a$/i.test(t)) return '(not previously tracked)'
  return t
}

export function truncateChangeCell (v, maxLen) {
  var cap = maxLen != null ? maxLen : CELL_TRUNCATE
  if (v == null) return { text: '', full: '', truncated: false }
  var t = String(v)
  if (t.length <= cap) return { text: t, full: t, truncated: false }
  return { text: t.slice(0, cap - 1) + '…', full: t, truncated: true }
}

export { CELL_TRUNCATE }



// WEBPACK FOOTER //
// ./src/utils/productDetailChangeMessage.js